import globalTheme, { muiTheme } from '../global'

const Pagination = {
	MuiPaginationItem: {
		styleOverrides: {
			icon: {
				color: globalTheme.palette.primary.main,
				height: 18,
				width: 18,
			},
			root: {
				border: '1px solid ' + globalTheme.palette.grey.light,
				borderRadius: globalTheme.shape.borderRadius,
				color: globalTheme.palette.primary.main,
				height: 34,
				lineHeight: 17 / 7,
				minWidth: 34,
				'&:not(.Mui-selected):hover': {
					backgroundColor: 'transparent',
					border: '1px solid ' + globalTheme.palette.grey.medium,
				},
				'&.Mui-selected': {
					backgroundColor: globalTheme.palette.primary.main,
					color: globalTheme.palette.common.white,
					cursor: 'default',
					'&:hover': {
						backgroundColor: globalTheme.palette.primary.main,
					},
				},
			},
			page: {
				fontSize: muiTheme.typography.pxToRem(12),
			},
		},
	},
}

export default Pagination
